<template>
  <div class="empty__state">
    <img src="../../../../assets/img/empty-state.png" alt="empty-state">
    <div class="empty__state__text">
      <span class="empty__state__title">Sem resultado na pesquisa</span>
      <span class="empty__state__subtitle">Caso esteja realizando alguma pesquisa, verifique os dados preenchidos e tente novamente!</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "emptyState"
}
</script>

<style lang="scss" scoped>

.empty__state {
  text-align: center;
  margin-top: 2rem;
  margin-bottom: 6rem;

  img {
    margin-bottom: 2rem;
  }

  &__text {
    display: flex;
    justify-content: center;
    flex-direction: column;

    width: 45%;
    margin: auto;
  }

  &__text > &__title {
    font-weight: 700;
    font-size: 16px;
    color: var(--dark-gray);
  }

  &__text > &__subtitle {
    font-weight: 400;
    font-size: 16px;
    color: var(--dark-gray);
  }
}

</style>



// WEBPACK FOOTER //
// src/vue/pages/components/layouts/emptyState.vue